import { render, staticRenderFns } from "./SelectPageDialog.vue?vue&type=template&id=45c2dbb9&scoped=true&"
import script from "./SelectPageDialog.vue?vue&type=script&lang=js&"
export * from "./SelectPageDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectPageDialog.vue?vue&type=style&index=0&id=45c2dbb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2dbb9",
  null
  
)

export default component.exports